import { byStartDateAsc, byStartDateDesc } from '../../lib/utils'
import { isEventActive } from '../../lib/formatDate'
import type { Event, GroupEvent } from '../../types'

export interface LinkedEvent {
  ge: GroupEvent
  event: Event
}

/** A group's linked events split into upcoming (soonest first) and past (latest first). */
export function splitLinkedEvents(groupEvents: GroupEvent[], events: Event[], now: Date) {
  const byId = new Map(events.map(e => [e.id, e]))
  const linked = groupEvents.flatMap(ge => {
    const event = byId.get(ge.eventId)
    return event ? [{ ge, event }] : []
  })
  const upcoming = linked.filter(x => isEventActive(x.event, now)).sort((a, b) => byStartDateAsc(a.event, b.event))
  const past = linked.filter(x => !isEventActive(x.event, now)).sort((a, b) => byStartDateDesc(a.event, b.event))
  return { upcoming, past }
}
